import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const ClosingStockAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    branchForListSearch,
    getIngredientItem,
    ingredientItemForSearch,
    dataPaginating,
  } = useContext(RestaurantContext);
  
  const { id } = useParams();
  const search = useLocation().search;
  const isDuplicate = new URLSearchParams(search).get('duplicate');

  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    date: new Date(),
    description: "",
    edit: false
  });

  //new Row
  const [newRow, setNewRow] = useState([]);

  //useEffect == componentDidMount()
  useEffect(() => {
    if (!ingredientItemForSearch) {
      getIngredientItem()
    }
  }, []);

  const getPurchasedItem = async () => {
    const url = BASE_URL + "/settings/closing-stock/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      const editOrder = res.data;
      if (editOrder) {
        let date = isDuplicate ? new Date() : new Date(editOrder.document_date);
        const branch = branchForListSearch[editOrder.branch_id]
        setNewItem({
          ...newItem,
          date,
          branch,
          description: !editOrder.remarks ? "" : editOrder.remarks,
          identity: editOrder.document_identity,
          edit: true
        })
        let slugArr = [];
        if (editOrder.closing_stock_detail && editOrder.closing_stock_detail.length > 0) {
          editOrder.closing_stock_detail.map((item) => {
            slugArr.push({
              ...item,
              base_unit: item.base_unit_id,
              qty: roundOffStock(item.qty),
              base_qty: roundOffStock(item.base_qty),
              conversion_qty: roundOffStock(item.conversion_qty),
              isEdit: true,
            })
          })
          setNewRow([...slugArr]);
        }
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getPurchasedItem()
    }
  }, [id])

  //on change input field
  const handleDesc = (e) => {
    setNewItem({ ...newItem, description: e.target.value });
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch, purchase_req: "" });
  };

  //set items hook
  const handleSetItems = async (index, item) => {
    newRow[index].unit = "";
    newRow[index].base_unit = "";
    newRow[index].base_qty = "";
    newRow[index].conversion_qty = "";
    newRow[index].item_name = item;
    newRow[index].base_unit = item.unit_id;
    newRow[index].item_units = ""
    setNewRow([...newRow]);
    const url = BASE_URL + "/settings/get-unit_item/" + item.id;
    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data) {
          newRow[index].item_units = res.data;
          newRow[index].unit = res.data[1];
          newRow[index].conversion_qty = roundOffStock(res.data[1].qty);
          setNewRow([...newRow]);
        }
      }).catch((error) => {
        console.log("check error", error);
      })
  };

  //handle unit
  const handleSetUnit = (index, unit) => {
    newRow[index].unit = unit;
    newRow[index].conversion_qty = roundOffStock(unit.qty);
    setNewRow([...newRow]);
  }

  //set each item qty
  const handleItemQty = (index, e) => {
    newRow[index].qty = e.target.value;
    setNewRow([...newRow]);
  };

  //post req of food item add
  const ingredientItemAxios = async () => {
    // setLoading(true);
    let date =
      new Date(newItem.date).getFullYear() +
      "-" +
      (new Date(newItem.date).getMonth() + 1) +
      "-" +
      new Date(newItem.date).getDate();

    //converting items and prices to array
    let duplicate = {};
    const duplicateItem = [];
    let slugArray = [];
    newRow.map((newIngredientItem, index) => {
      if (duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id]) {
        duplicateItem.push({
          item_id: newIngredientItem?.item_id || newIngredientItem.item_name.id,
          item_name: newIngredientItem.item_name?.name || newIngredientItem.item_name,
        })
      }
      if (newIngredientItem.item_name === "" || newIngredientItem.unit === "") {
        slugArray.push();
      } else {
        duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id] = true;
        slugArray.push({
          qty: newIngredientItem.qty,
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,
          unit_id: newIngredientItem.isEdit ? newIngredientItem.unit_id : newIngredientItem.unit.id,
          unit_name: newIngredientItem.isEdit ? newIngredientItem.unit : newIngredientItem.unit.name,
          base_unit_id: newIngredientItem.base_unit,
          base_qty: calBaseQty(index),
          conversion_qty: parseFloat(newIngredientItem.conversion_qty)
        });
      }
    });

    if (duplicateItem?.length) {
      ToastError({ title: `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}` });
      return;
    }

    let formData = {
      branch_id: newItem.branch.id,
      branch_name: newItem.branch.name,
      document_date: date,
      remarks: newItem.description,
      items: slugArray
    }

    if (newRow.length === slugArray.length) {
      setLoading(true);
      const endPoint = (id && !isDuplicate) ? ("/settings/closing-stock/" + id) : "/settings/closing-stock";
      const url = BASE_URL + endPoint;
      const method = (id && !isDuplicate) ? "put" : "post";
      try {
        const res = await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        ToastSuccess({ title: `${_t(t((id && !isDuplicate) ? "Closing Stock has been updated" : "Closing Stock has been added"))}` });
        history.push("/dashboard/manage/stock/closing-stock")
      } catch (error) {
        setLoading(false);
        if(error.response.data.status === 0){
          ToastError({ title: error.response.data.message });
          return
        }
        ToastError({ title: `${_t(t("Please try again later"))}` });
      }
    } else {
      ToastError({ title: `${_t(t("Please select all dropdowns"))}` });
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.date !== null
    ) {
      if (newRow.length > 0) {
        ingredientItemAxios();
      } else {
        ToastError({ title: `${_t(t("Please add orders"))}` });
      }
    } else {
      ToastError({ title: `${_t(t("Please fill all required fields"))}` });
    }
  };

  const calBaseQty = (index) => {
    let qty = newRow[index].qty;
    let conversion_qty = newRow[index].conversion_qty
    if (qty && conversion_qty) {
      return roundOffStock(qty * conversion_qty);
    } else {
      return "";
    }
  }

  const addNewRow = () => {
    // if(newOpeningStock.branch !== null){
    setNewRow((pre) => [...pre, {
      item_name: "",
      qty: "",
      unit: "",
      item_units: "",
      rate: "",
      base_unit: "",
      base_qty: "",
      conversion_qty: ""
    }])
  }

  const delRow = (id) => {
    let row = [...newRow];
    if (id > -1) {
      row.splice(id, 1);
    }
    setNewRow(row);
  }

  return (
    <>
      <Helmet>
        <title>{_t(t((id && !isDuplicate) ? "Edit Closing Stock" : "Add Closing Stock"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${loading && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {dataPaginating === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t((id && !isDuplicate) ? "Edit Closing Stock" : "Add Closing Stock"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              {branchForSearch && (
                                <>
                                  <div className="form-group col-4 mt-2">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="invoice"
                                        className="control-label"
                                      >
                                        {_t(t("Invoice #"))}
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <input
                                        disabled={true}
                                        type="text"
                                        className="form-control table-text"
                                        id="invoice"
                                        name="invoice"
                                        value={newItem.identity}
                                        placeholder="Auto No"
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group col-4 mt-2">
                                    <div className="mb-2 ">
                                      <label
                                        htmlFor="purchaseDate"
                                        className="control-label"
                                      >
                                        {_t(t("Closing Date"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <DatePicker
                                        selected={newItem.date}
                                        onChange={(date) => setNewItem({ ...newItem, date })}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control table-text"
                                        placeholderText={_t(t("closing date"))}
                                        shouldCloseOnSelect={false}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group mt-2 col-4">
                                    <div className="mb-1 text-left">
                                      <label
                                        htmlFor="branch"
                                        className="control-label text-truncate"
                                      >
                                        {_t(t("Branch"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={branchForSearch}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.branch || ""}
                                      isDisabled={id && !isDuplicate}
                                      classNamePrefix="select"
                                      onChange={handleSetBranch}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select branch")) + ".."
                                      }
                                      styles={customStyle}
                                      required
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="row">
                              
                              <div className="form-group mt-2 col-12">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Description"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={handleDesc}
                                    value={newItem.description}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive mt-3 pr-1" style={{ maxHeight: "23rem", overflow: "auto" }}>
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length == 0 ? <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={() => addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                      </span>
                                    </th> : <th style={{ borderBottomColor: "lightgray" }}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border "
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>

                                    {/* <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                      {_t(t("Base unit"))}
                                      </span>
                                    </th>
                                      
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                      {_t(t("Base qty"))}
                                      </span>
                                    </th> */}

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "9rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Conversion unit"))}
                                      </span>
                                    </th>
                                    {newRow.length > 0 && <th style={{ borderBottomColor: "lightgray", minWidth: "60px" }}></th>}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ?
                                  <tbody className="align-middle">
                                    {newRow.map(
                                      (ingredientItem, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px" }}>
                                              {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                              </span>}&nbsp;
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }}
                                                onClick={() => {delRow(index) }}
                                              ></i>
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center table-Child">
                                              {ingredientItem?.isEdit ?
                                                <input
                                                  readOnly
                                                  type="text"
                                                  className={`form-control text-center table-Input table-text`}
                                                  value={ingredientItem.item_name || ""}
                                                />
                                                :
                                                <Select
                                                  options={ingredientItemForSearch}
                                                  getOptionLabel={(option) => option.name}
                                                  getOptionValue={(option) => option.id}
                                                  classNamePrefix="select table-text"
                                                  onChange={(e) => handleSetItems(index, e)}
                                                  value={ingredientItem.item_name}
                                                  placeholder={
                                                    _t(t("Please select items")) + ".."
                                                  }
                                                  menuPosition="fixed"
                                                  styles={customStyle}
                                                />
                                              }
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e) => handleItemQty(index, e)}
                                                value={ingredientItem.qty}
                                                placeholder="Qty"
                                                required
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {ingredientItem?.isEdit ?
                                                <input
                                                  readOnly
                                                  type="text"
                                                  className={`form-control text-center table-Input table-text`}
                                                  value={ingredientItem.unit || ""}
                                                />
                                                :
                                                <Select
                                                  menuPosition="fixed"
                                                  options={ingredientItem.item_units ? ingredientItem.item_units : []}
                                                  getOptionLabel={(option) => option.name}
                                                  getOptionValue={(option) => option.id}
                                                  value={ingredientItem.unit}
                                                  classNamePrefix="select"
                                                  onChange={(e) => handleSetUnit(index, e)}
                                                  styles={customStyle}
                                                  placeholder={
                                                    _t(t("please select unit")) + ".."
                                                  }
                                                  isDisabled={ingredientItem.item_units ? false : true}
                                                />
                                              }
                                            </td>

                                            <td className="table-text align-middle text-center">
                                              {ingredientItem.conversion_qty}
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "60px" }}>
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }} onClick={() => delRow(index)}></i>&nbsp;
                                              {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                              </span>}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  : null}
                              </table>
                            </div>
                            <div className="form-group mt-4 pb-2">
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={() => (history.push("/dashboard/manage/stock/closing-stock"))}
                                  >
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t(id && !isDuplicate ? "Update" : "Save"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  )
}

export default ClosingStockAction
